import "./HowToCalc.less"
import CalculatorStore from "../../Configs/Store/calculator"
import HowToCalcjson from "../../Configs/JSON/HowToCalc.json"
import { observer } from "mobx-react"
import Icon1 from "../../assets/HowToClac/Step1.svg"


const HowToCalc = observer(() => {
    // const device = AppStore.device
    const HowToCalcsJson = HowToCalcjson.SectionConfig
    const JsonData = HowToCalcjson["data"]

    return (
        <div className="HowToCalcRoot">
            <div className="HowToCalcContainer">
                <h2 className="HowToCalcTitle">{HowToCalcsJson.title}</h2>
                <div className="HowToCalcSubTitle">{HowToCalcsJson.content}</div>
                <div className="StepsContainer">
                    {
                        JsonData.map((value, index) => (
                            <div className={`Container Container${value.icon}`}>
                                <img src={`assets/HowToClac/${value.icon}.svg`} className={value.icon} alt={value.icon} width="50" height="50" />
                                <div>
                                    <div className={`SubTitle${value.icon} SubTitle`}>{value.subTitle}</div>
                                    <h3 className={`Title${value.icon} Title`}>{value.title}</h3>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div >
        </div>
    )

})

export default HowToCalc